(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-seo-content"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.vfCseoInit) return; window.vfCseoInit = true;

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-vf-cseo-btn]'); if (!btn) return;
    var wrap = btn.closest('.vf-cseo'), more = wrap.querySelector('.vf-cseo__more');
    var open = btn.getAttribute('aria-expanded') === 'true';
    more.hidden = open;
    btn.setAttribute('aria-expanded', String(!open));
    btn.querySelector('span').textContent = open ? 'Read more' : 'Read less';
    if (open) wrap.scrollIntoView({behavior:'smooth', block:'start'});
  });

  function addFaqSchema(){
    if (document.getElementById('vf-cseo-faq-ld')) return;
    var qs = document.querySelectorAll('.vf-cseo__q'); if (!qs.length) return;
    var data = {'@context':'https://schema.org','@type':'FAQPage','mainEntity':[]};
    Array.prototype.forEach.call(qs, function(q){
      var h = q.querySelector('h3'); if (!h) return;
      var a = Array.prototype.map.call(q.querySelectorAll('p'), function(p){ return p.textContent.trim(); }).join(' ');
      data.mainEntity.push({'@type':'Question','name':h.textContent.trim(),'acceptedAnswer':{'@type':'Answer','text':a}});
    });
    var s = document.createElement('script');
    s.type = 'application/ld+json'; s.id = 'vf-cseo-faq-ld'; s.textContent = JSON.stringify(data);
    document.head.appendChild(s);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addFaqSchema); else addFaqSchema();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-florists-choice"]) return;
  try {
    
 document.addEventListener("DOMContentLoaded", function () {
  let isReloading = false;
  function handleReload() {
    if (isReloading) return;
    isReloading = true;
    setTimeout(() => {
      location.reload();
    }, 100);
  }

  document.addEventListener("click", function (e) {
    const target = e.target.closest(
      ".cus-standard_lble, .cus-occasion_reminder_bundle_lble"
    );
    if (target) {
      handleReload();
    }
  });
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
